import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { NewsWithViewStatus } from '../../types/news';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../Dialog/Dialog';
import { Badge } from '../Badge/Badge';

interface NewsDetailsModalProps {
  news: NewsWithViewStatus | null;
  isOpen: boolean;
  onClose: () => void;
}

export const NewsDetailsModal: React.FC<NewsDetailsModalProps> = ({
  news,
  isOpen,
  onClose
}) => {
  const { t } = useTranslation();
  
  if (!news) return null;

  const formatDate = (dateString: string) => {
    try {
      return format(new Date(dateString), 'MMMM dd, yyyy');
    } catch {
      return t('news.invalid_date') || 'Invalid date';
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <DialogTitle className="text-xl font-semibold text-foreground pr-8">
                {news.title}
              </DialogTitle>
              <div className="flex items-center space-x-2 mt-2">
                {!news.viewed && (
                  <Badge variant="secondary">
                    {t('news.new_badge') || 'New'}
                  </Badge>
                )}
                <span className="text-sm text-muted-foreground">
                  {formatDate(news.date)}
                </span>
              </div>
            </div>
            {/* <DialogClose asChild>
              <CloseButton fn={onClose} />
            </DialogClose> */}
          </div>
        </DialogHeader>
        
        <div className="mt-4">
          <div className="prose prose-sm max-w-none">
            <p className="text-foreground leading-relaxed whitespace-pre-wrap">
              {news.content}
            </p>
          </div>
          
          <div className="mt-6 pt-4 border-t border-gray-200">
            <div className="text-sm text-muted-foreground">
              <span>{t('news.published_on') || 'Published on'} {formatDate(news.date)}</span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
